module.exports = __webpack_public_path__ + "img/kunshan.73b9f4b.png";